import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class PromotionService {

    constructor(private api: ApiService) {
    }

    getPromotions(query?: any) {
        return this.api.get(this.api.path + '/promotion', query);
    }

    insert(data: any) {
        return this.api.post(this.api.path + '/promotion', data);
    }

    update(id: any, data: any) {
        return this.api.post(this.api.path + '/promotion/' + id, data);
    }

    delete(id: number | any) {
        return this.api.delete(this.api.path + '/promotion/' + id);
    }
}
